export default "__VITE_ASSET__4gIazHnu__"